module.exports = __webpack_public_path__ + "img/zsjm-8.20a05e1b.webp";